import { toast } from '@/lib/toast';
import api from '@/api';
import ProcedureReturnToPublished from "@/components/procedure/ProcedureReturnToPublished.vue";
import i18n from "@/plugins/i18n"

export const DialogList = {
    cancelProcedure: true
}

export const ActionList = {
    actionsMap: {
        recallApplication: {
            text: 'Отозвать',
            async handler(ctx) {
                const application = await ctx.$refs.confirm.open(
                  'Отзыв заявки',
                  i18n.global.t(`Вы действительно хотите отозвать поданную заявку по процедуре {_1}?`, {'_1': ctx.item.p.registryNumber})
                );
                if (application) {
                    const procedureId = ctx.item.p.id;
                    try {
                        ctx.loadingDialogText = 'Заявка отзывается';

                        await api.delete(`/procedures/cancelApplication/${procedureId}`);

                        ctx.tableModel.reload();
                    } catch (e) {
                        toast.error(e.message);
                    } finally {
                        ctx.loadingDialogText = null;
                    }
                }
            },
        },
        deleteProcedureDraft: {
            text: 'Удалить черновик',
            async handler(ctx) {
                const shouldDelete = await ctx.$refs.confirm.open(
                  'Удалить черновик',
                  'Вы действительно хотите удалить черновик процедуры?'
                );
                if (shouldDelete) {
                    const procedureId = ctx.item.p.id;
                    try {
                        ctx.loadingDialogText = 'Удаляется';
                        const resp = await api.post('/procedures/deleteDraft/' + procedureId);
                        if (ctx.$router.currentRoute.value.fullPath === "/procedures") {
                            ctx.tableModel.reload();
                        } else {
                            ctx.$router.replace('/procedures');
                        }
                    } catch (e) {
                        toast.error(e.message);
                    } finally {
                        ctx.loadingDialogText = null;
                    }
                }
            }
        },
        viewPublicProcedure: {
            text: 'Просмотреть',
            handler(ctx) {
                const procedureId = ctx.item.p.id;
                const route = ctx.$router.resolve({
                    name: 'public.procedures.view',
                    params: { id: procedureId },
                });
                window.open(route.href, '_blank');
            },
        },
        viewProcedure: {
            text: 'Просмотреть',
            handler(ctx) {
                const procedureId = ctx.item.p.id;
                const route = ctx.$router.resolve({
                    name: 'procedures.view',
                    params: { id: procedureId },
                });
                window.open(route.href, '_blank');
            },
        },
        copyProcedure: {
            text: 'Копировать',
            async handler(ctx) {
                const shouldCopy = await ctx.$refs.confirm.open(
                  'Копировать процедуру',
                  'Вы действительно хотите создать копию процедуры?'
                );

                if (shouldCopy) {
                    const procedureId = ctx.item.p.id;
                    try {
                        ctx.loadingDialogText = 'Копируется';
                        const resp = await api.post('/procedures/copy/' + procedureId);

                        ctx.$router.replace({
                            name: 'procedures.edit',
                            params: { id: resp.id },
                        });
                    } catch (e) {
                        toast.error(e.message);
                    } finally {
                        ctx.loadingDialogText = null;
                    }
                }
            },
        },
        viewResultsProcedure: {
            text: 'Просмотреть результаты',
            handler(ctx) {
                const procedureId = ctx.item.p.id;
                const route = ctx.$router.resolve({
                    name: 'procedures.view',
                    params: { id: procedureId }
                });
                window.open(route.href, '_blank');
            }
        },
        viewCompletedProcedure: {
            text: 'Просмотреть итоги',
            handler(ctx) {
                const procedureId = ctx.item.p.id;
                const route = ctx.$router.resolve({
                    name: 'procedures.completed',
                    params: { id: procedureId },
                });
                window.open(route.href, '_blank');
            },
        },
        reviewProcedure: {
            text: 'Рассмотреть заявки',
            handler(ctx) {
                const procedureId = ctx.item.p.id;
                const route = ctx.$router.resolve({
                    name: 'procedures.review',
                    params: { id: procedureId },
                });
                window.open(route.href, '_blank');
            }
        },
        editProcedure: {
            text: 'Редактировать',
            handler(ctx) {
                const procedureId = ctx.item.p.id;
                const route = ctx.$router.resolve({
                    name: 'procedures.edit',
                    params: { id: procedureId },
                });
                window.open(route.href, '_blank');
            },
        },
        viewApplication: {
            text: 'Просмотреть заявку',
            async handler(ctx) {
                const procedureId = ctx.item.p.id;
                const resp = await api.get('/applications/getId/' + procedureId);
                const route = ctx.$router.resolve({
                    name: 'application.procedure.view',
                    params: { 
                        applicationId: resp.applicationId,
                        procedureId: procedureId
                    },
                });
                window.open(route.href, '_blank');
            },
        },
        applyApplication: {
            text: 'Подать заявку',
            async handler(ctx) {
                const procedureId = ctx.item.p.id;
                const resp = await api.get('/applications/getId/' + procedureId);
                const route = ctx.$router.resolve({
                    name: resp.applicationId ? 'application.procedure.edit_draft' : 'applications.procedure',
                    params: {
                        applicationId: resp.applicationId,
                        procedureId: procedureId
                    }
                });
                window.open(route.href, '_blank');
            },
        },
        editDraftApplication: {
            text: 'Редактировать черновик заявки',
            async handler(ctx) {
                const procedureId = ctx.item.p.id;
                const resp = await api.get('/applications/getId/' + procedureId);
                const route = ctx.$router.resolve({
                    name: resp.applicationId ? 'application.procedure.edit_draft' : 'applications.procedure',
                    params: {
                        applicationId: resp.applicationId,
                        procedureId: procedureId
                    }
                });
                window.open(route.href, '_blank');
            },
        },
        editApplication: {
            text: 'Редактировать заявку',
            async handler(ctx) {
                const procedureId = ctx.item.p.id;
                const resp = await api.get('/applications/getId/' + procedureId);
                const route = ctx.$router.resolve({
                    name: 'application.procedure.edit',
                    params: {
                        applicationId: resp.applicationId,
                        procedureId: procedureId
                    }
                });
                window.open(route.href, '_blank');
            },
        },
        viewAllApplications: {
            text: 'Просмотреть заявки',
            handler(ctx) {
                const procedureId = ctx.item.p.id;
                const route = ctx.$router.resolve({
                    name: 'procedures.viewApps',
                    params: { id: procedureId },
                });
                window.open(route.href, '_blank');
            }
        },
        summingProcedure: {
            text: 'Подвести итоги',
            handler(ctx) {
                const procedureId = ctx.item.p.id;
                const route = ctx.$router.resolve({
                    name: 'procedures.summarize',
                    params: { id: procedureId },
                });
                window.open(route.href, '_blank');
            },
        },
        returnToPublishedProcedure: {
            text: 'Вернуть на приём заявок',
            async handler(ctx) {
                ctx.dialogStore.openDialog(ProcedureReturnToPublished, {
                    procedureId: ctx.item.p.id,
                    procedure: ctx.item.p,
                    onSuccess: async () => {
                        try {
                            ctx.loadingDialogText = 'Процедура возвращается на предыдущий шаг';
                            await ctx.tableModel.reload();
                        } catch (e) {
                            toast.error(e.message);
                        } finally {
                            ctx.loadingDialogText = null;
                        }
                    },
                });
            },
        },
    },

    /**
     * Возвращает массив действий.
     * @param {string[]} actionNames
     * @returns {Array<{ text: string, handler: Function }>}
     */
    getActions(actionNames, ctx) {
        const me = this;
        return actionNames
            .map((actionName) => {
                const action = this.actionsMap[actionName];
                if (!action) {
                    toast.error(i18n.global.t(`Действие "{_1}" не найдено`, {'_1': actionName}));
                    return null;
                }
                return {
                    text: action.text,
                    handler: function () {
                        action.handler(ctx, me);
                    },
                };
            })
            .filter((action) => action);
    },
};
